import React from 'react';
import { IconType } from 'react-icons';
import { IconBaseProps } from 'react-icons/lib';

interface IconWrapperProps extends IconBaseProps {
  icon: IconType;
}

export const IconWrapper: React.FC<IconWrapperProps> = ({ icon: Icon, ...props }) => {
  return React.createElement(Icon as React.ComponentType<IconBaseProps>, props);
}; 